import React, { useState, useEffect } from "react";
import Header from "../components/Header/Header";
import Navbar from "../components/Navbar/Navbar";
import Sidebar from "../components/Sidebar/Sidebar";
import MainContent from "../components/MainContent/MainContent";
import logo from "../assets/logo.png";
import api from "../services/api";
import { HeaderWrapper } from "./MainLayout.styles"; // Import do novo styled

const MainLayout = ({ children }) => {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  const [username, setUsername] = useState(null)
  const [role, setRole] = useState(null)

  useEffect(() => {
    carregaDadosUser()
  }, [])

  const toggleSidebar = () => {
    setIsSidebarExpanded((prev) => !prev);
  };
  
  const carregaDadosUser = async () => {
    try{ 
      const response = await api.get('/users/me')

      setUsername(response.data.nome)
      setRole(response.data.perfil)
    } catch (error) {
      console.error("Erro ao carregar os dados do usuário")
    }
  }

  return (
    <div>
      <Header isSidebarExpanded={isSidebarExpanded} />

      <Navbar
        logo={logo}
        username={username}
        userRole={role}
        profilePicture="https://via.placeholder.com/40"
        onToggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarExpanded}
      />

      <Sidebar
        isExpanded={isSidebarExpanded}
        toggleSidebar={toggleSidebar}
      />

      <MainContent isSidebarExpanded={isSidebarExpanded}>
        {children}
      </MainContent>
    </div>
  );
};

export default MainLayout;
